import gql from 'graphql-tag';

export default gql`
mutation ($emailAddress: String!, $name: String!, $role:String!) {
    createUser (input: {
        emailAddress: $emailAddress
        name: $name
        role: $role,
    }) {
        __typename
        id
        emailAddress
        name
        status
        active
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Users/NewMutation.js